if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartDrawer = document.querySelector('cart-drawer');
      this.cartSummary = document.querySelector('cart-summary');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      const submitButton = this.querySelector('[type="submit"]');
      submitButton.setAttribute('disabled', true);
      submitButton.classList.add('loading');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const sectionsToFetch = [
        ...(this.cartDrawer ? this.cartDrawer.getSectionsToRender().map((section) => section.id) : []),
        ...(this.cartSummary ? this.cartSummary.getSectionsToRender().map((section) => section.id) : [])
      ];

      // The cart drawer already requests cart-icon-bubble; on pages without a
      // drawer (e.g. a standard PDP) request it directly so the header count
      // refreshes after adding to cart.
      if (!this.cartDrawer && !sectionsToFetch.includes('cart-icon-bubble')) {
        sectionsToFetch.push('cart-icon-bubble');
      }

      const formData = new FormData(this.form);
      formData.append('sections', sectionsToFetch);
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      const variantId = formData.get('id');
      const requestedQty = parseInt(formData.get('quantity'), 10) || 1;
      let prevQty = 0;
      const cartStateEl = document.getElementById('cart-state');
      if (cartStateEl && variantId) {
        const items = parseJson(cartStateEl.textContent);
        if (Array.isArray(items)) {
          const item = items.find((i) => String(i.variant_id) === String(variantId));
          prevQty = item?.quantity || 0;
        }
      }

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((parsedState) => {
          if (parsedState.status == 422) {
            // When quantity error
            const inventoryQty = parseInt(formData.get('inventory_quantity'), 10) || 0;
            const message = window.cartStrings && window.cartStrings.quantityError
              ? window.cartStrings.quantityError.replace('[quantity]', inventoryQty)
              : parsedState.description;
            document.dispatchEvent(new CustomEvent('cart:toast', {
              detail: {
                type: 'error',
                message
              }
            }));
            return;
          }

          this.cartDrawer && this.cartDrawer.renderContents(parsedState);
          this.cartSummary && this.cartSummary.renderContents(parsedState);
          if (!this.cartDrawer) this.renderCartIconBubble(parsedState);

          const behavior = submitButton.dataset.addToCartBehavior;

          switch (behavior) {
            case ('open_cart_drawer'):
              this.cartDrawer && this.cartDrawer.open();
              break;
            case ('show_toast'):
            default: {
              const addedCount = parsedState.quantity != null
                ? Math.abs(parsedState.quantity - prevQty)
                : requestedQty;
              document.dispatchEvent(new CustomEvent('cart:toast', {
                detail: {
                  count: addedCount || requestedQty,
                  type: 'add'
                }
              }));
            }
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('disabled');
        });
    }

    renderCartIconBubble(parsedState) {
      const sectionHtml = parsedState.sections?.['cart-icon-bubble'];
      if (!sectionHtml) return;

      const target = document.querySelector('[data-cart-icon-bubble]');
      if (!target) return;

      const newContent = new DOMParser()
        .parseFromString(sectionHtml, 'text/html')
        .querySelector('[data-cart-icon-bubble]');

      if (newContent) target.innerHTML = newContent.innerHTML;
    }
  }

  window.ProductForm = ProductForm;
  customElements.define('product-form', ProductForm);
}


